// 个人中心路由

const UserCenter = [
    // 消息中心
    {
        path: '/message',
        component: resolve => require(['@/views/UserCenter/Message/Message'], resolve),
        name: 'messageCenter',
        meta: { title: '消息中心', breadcrumb: [{ menu: 'messageCenter' }] }
    },
    // 消息详情页

    // 修改密码
    {
        path: '/changepassword',
        component: resolve => require(['@/views/UserCenter/ChangePassword'], resolve),
        name: 'changePassword',
        meta: { title: '修改密码',  breadcrumb: [{ menu: 'changePassword' }] }
    },
    // 个人设置
	{
	    path: '/usercenter',
	    component: resolve => require(['@/views/UserCenter/UserCenter'], resolve),
	    name: 'userEmail',
	    meta: { title: '绑定邮箱',  breadcrumb: [{ menu: 'userEmail' }] }
	},
];

export default UserCenter